/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum EncounterPatientDetailCpoeAliases {
  FRAGMENT_CPOE = 'fragment-cpoe',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  GENERAL_LAYOUT_CPOE = 'general-layout-cpoe',
  PANEL_CONTAINER_MAIN = 'panel-container-main',
  TEXT_AREA_PANEL = 'text-area-panel',
}
export { EncounterPatientDetailCpoeAliases };
